// import React, { useContext, useEffect, useMemo } from "react";
// import { Card, Grid, Typography } from "@mui/material";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { useLocation } from "react-router-dom";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
// import Navlogo from "../../assets/images/logo/NavLogo.png";
// import axios from "axios";
// import { useState } from "react";
// import { BrandingContext } from "../../BrandingProvider";
// import { toast } from "react-toastify";

// const ViewEstimate = () => {
//   const brandingData = useContext(BrandingContext);
//   const location = useLocation();
//   const { data } = location.state || {};
//   console.log("testing..", data);
//   const history = useHistory();
//   useEffect(() => {
//     if (
//       sessionStorage.getItem("accessToken") == undefined &&
//       sessionStorage.getItem("accessToken") == null
//     ) {
//       history.push("/login");
//     }
//   }, []);
//   const [authToken, setAuthToken] = useState(
//     sessionStorage.getItem("accessToken") !== undefined &&
//       sessionStorage.getItem("accessToken") !== null
//       ? sessionStorage.getItem("accessToken")
//       : ""
//   );
//   const headers = {
//     Authorization: `Bearer ${authToken}`,
//   };
//   const normalConfig = useMemo(
//     () => ({
//       buttons: "",
//       minHeight: "0",
//       toolbar: false,
//       showPlaceholder: false,
//       style: {
//         padding: "0px",
//         width: "100%",
//         backgroundColor: "#fff",
//         color: "#000",
//         fontWeight: "bold",
//       },
//       showXPathInStatusbar: false,
//       showCharsCounter: false,
//       showWordsCounter: false,
//       toolbarAdaptive: false,
//       enableDragAndDropFileToEditor: true,
//     }),
//     []
//   );
//   const [pdfDataUri, setPdfDataUri] = useState(null);
//   const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

//   const handleDownload = async () => {
//     const input = document.getElementById("invoice-template");
//     html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
//       (canvas) => {
//         const image = { type: "jpeg", quality: 0.98 };
//         const margin = [0.5, 0.5];

//         var imgWidth = 8.5;
//         var pageHeight = 11;

//         var innerPageWidth = imgWidth - margin[0] * 2;
//         var innerPageHeight = pageHeight - margin[1] * 2;

//         var pxFullHeight = canvas.height;
//         var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
//         var nPages = Math.ceil(pxFullHeight / pxPageHeight);

//         var pageHeight = innerPageHeight;

//         var pageCanvas = document.createElement("canvas");
//         var pageCtx = pageCanvas.getContext("2d");
//         pageCanvas.width = canvas.width;
//         pageCanvas.height = pxPageHeight;

//         var pdf = new jsPDF("p", "in", [8.5, 11]);

//         for (var page = 0; page < nPages; page++) {
//           if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
//             pageCanvas.height = pxFullHeight % pxPageHeight;
//             pageHeight =
//               (pageCanvas.height * innerPageWidth) / pageCanvas.width;
//           }

//           var w = pageCanvas.width;
//           var h = pageCanvas.height;
//           pageCtx.fillStyle = "white";
//           pageCtx.fillRect(0, 0, w, h);
//           pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

//           if (page > 0) pdf.addPage();
//           var imgData = pageCanvas.toDataURL(
//             "image/" + image.type,
//             image.quality
//           );
//           pdf.addImage(
//             imgData,
//             image.type,
//             margin[1],
//             margin[0],
//             innerPageWidth,
//             pageHeight
//           );
//         }

//         pdf.save(`Invoice.pdf`);
//       }
//     );
//   };
//   const handleHomeButton = () => {
//     history.push("/doctor/estimates");
//   };

//   const collateralImage =
//     brandingData?.find((item) => item.name === "collateral_image.png")
//       ?.content || null;
//   const collateralBrandStatement =
//     brandingData?.find((item) => item.name === "branding_statements.json")
//       ?.content.collateralBrandStatement || null;
//   return (
//     <>
//       <Card
//         style={{
//           width: "85%",
//           height: "100%",
//           padding: "16px",
//           marginLeft: "10%",
//         }}
//       >
//         <div id="invoice-template">
//           {data ? (
//             <Card style={{ height: "auto" }}>
//               <Grid container>

//                 {/* Collateral Image and Brand Statement */}
//                 <Grid container item xs={12} alignItems="center">
//                 <Grid item xs={3} md={3}></Grid>
//                   {/* Collateral Image in the center */}
//                   <Grid item xs={5} textAlign="center">
//                     {collateralImage && (
//                       <img
//                         src={`data:image/png;base64,${collateralImage}`}
//                         alt="Collateral"
//                         width="100px"
//                         height="60px"
//                         style={{ paddingBottom: "3px", paddingTop: "5px" }}
//                       />
//                     )}
//                     {collateralBrandStatement && (
//                       <Typography variant="subtitle1" color="grey">
//                         {collateralBrandStatement}
//                       </Typography>
//                     )}
//                   </Grid>

//                   {/* Empty space on the left */}

//                   {/* Navlogo on the Right */}
//                   <Grid item xs={2.5} textAlign="right">
//                     <img
//                       src={Navlogo}
//                       className="logo-dark logo-img"
//                       alt="logo"
//                       width="100px"
//                       height="60px"
//                       style={{ paddingBottom: "3px", paddingTop: "5px" }}
//                     />
//                   </Grid>
//                 </Grid>

//                 {/* Patient and Estimate Details */}
//                 <Grid item xs={12}>
//                   <Grid
//                     container
//                     sx={{
//                       borderTop: "1px solid #ccc",
//                       borderBottom: "1px solid #ccc",
//                       padding: 2,
//                     }}
//                   >
//                     <Grid item xs={12}>
//                       <Grid container>
//                         <Grid item xs={12} sm={6} md={6} >
//                           <Typography variant="subtitle1" color="grey">
//                             Patient Name: <b>{data.patient_name}</b>
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={2} sm={2} md={3.5}></Grid>
//                         <Grid item xs={12} sm={6} md={2.5} >
//                           <Typography variant="subtitle1" color="grey">
//                             Notes: <b>{data.note}</b>
//                           </Typography>
//                           <Typography variant="subtitle1" color="grey">
//                             Estimate Date: <b>{data.estimate_date}</b>
//                           </Typography>
//                           <Typography variant="subtitle1" color="grey">
//                             Expiry Date: <b>{data.expiry_date}</b>
//                           </Typography>
//                           <Typography variant="subtitle1" color="grey">
//                             Estimate Number: <b>{data.estimate_number}</b>
//                           </Typography>
//                         </Grid>
//                       </Grid>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </Grid>

//               {/* Invoice Items Section */}
//               <Grid item xs={12}>
//                 <Grid
//                   container
//                   sx={{
//                     borderTop: "1px solid #ccc",
//                     borderBottom: "1px solid #ccc",
//                     padding: 2,
//                   }}
//                 >
//                   <Grid item xs={3}>
//                     <Typography variant="h6">Item</Typography>
//                   </Grid>
//                   <Grid item xs={3}>
//                     <Typography variant="h6">Price</Typography>
//                   </Grid>
//                   <Grid item xs={3}>
//                     <Typography variant="h6">Quantity</Typography>
//                   </Grid>
//                   <Grid item xs={3}>
//                     <Typography variant="h6">Subtotal</Typography>
//                   </Grid>
//                 </Grid>

//                 {data.items.map((item, index) => (
//                   <Grid
//                     container
//                     key={index}
//                     sx={{
//                       borderTop: "1px solid #ccc",
//                       borderBottom: "1px solid #ccc",
//                       padding: 2,
//                     }}
//                   >
//                     <Grid item xs={3}>
//                       <Typography variant="subtitle1" color="grey">
//                         <b>{item.item_name}</b>
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={3}>
//                       <Typography variant="subtitle1" color="grey">
//                         <b>{item.item_price}</b>
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={3}>
//                       <Typography variant="subtitle1" color="grey">
//                         <b>{item.quantity}</b>
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={3}>
//                       <Typography variant="subtitle1" color="grey">
//                         <b>{item.subtotal}</b>
//                       </Typography>
//                     </Grid>
//                   </Grid>
//                 ))}
//               </Grid>

//               {/* Additional Invoice Details */}
//               <Grid item xs={12}>
//                 <Grid
//                   container
//                   sx={{
//                     marginTop: "55px",
//                     marginLeft: "30%",
//                   }}
//                 >
//                   <Grid item xs={12} md={6}></Grid>
//                   <Grid item xs={12} md={6} padding={2}>
//                     <Typography variant="subtitle1" color="grey">
//                       Total Amount: <b>{data.total_amount}</b>
//                     </Typography>
//                     <Typography variant="subtitle1" color="grey">
//                       Discount(%): <b>{data.discount}</b>
//                     </Typography>
//                     <Typography variant="subtitle1" color="grey">
//                       Tax(%): <b>{data.tax}</b>
//                     </Typography>
//                     <Typography variant="subtitle1" color="grey">
//                       Total: <b>{data.total}</b>
//                     </Typography>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Card>
//           ) : (
//             <h1>Loading Invoice</h1>
//           )}
//         </div>
//         <div style={{ textAlign: "center", marginTop: "20px" }}>
//           <button
//             onClick={handleDownload}
//             className="listening-button"
//             style={{ marginRight: "10px" }}
//           >
//             Download
//           </button>

//           <button onClick={handleHomeButton} className="listening-button">
//             Go to Home
//           </button>
//         </div>
//       </Card>
//     </>
//   );
// };

// export default ViewEstimate;
import React, { useContext, useEffect, useMemo } from "react";
import { Button, Card, Grid, Typography } from "@mui/material";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Navlogo from "../../assets/images/logo/NavLogo.png";
import { useState } from "react";
import { BrandingContext } from "../../BrandingProvider";
import FooterPdfTemplate from "../Branding/FooterPdfTemplate";
import { displayPatientName } from "../../utils/displayPatientName";

const ViewEstimate = () => {
  const brandingData = useContext(BrandingContext);
  const location = useLocation();
  const { data } = location.state || {};
  const history = useHistory();
  console.log("data", data);
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  // const handleDownload = async () => {
  //   const input = document.getElementById("estimate-template");
  //   html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
  //     (canvas) => {
  //       const image = { type: "jpeg", quality: 0.98 };
  //       const margin = [0.5, 0.5];

  //       var imgWidth = 8.5;
  //       var pageHeight = 11;

  //       var innerPageWidth = imgWidth - margin[0] * 2;
  //       var innerPageHeight = pageHeight - margin[1] * 2;

  //       var pxFullHeight = canvas.height;
  //       var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
  //       var nPages = Math.ceil(pxFullHeight / pxPageHeight);

  //       var pageHeight = innerPageHeight;

  //       var pageCanvas = document.createElement("canvas");
  //       var pageCtx = pageCanvas.getContext("2d");
  //       pageCanvas.width = canvas.width;
  //       pageCanvas.height = pxPageHeight;

  //       var pdf = new jsPDF("p", "in", [8.5, 11]);

  //       for (var page = 0; page < nPages; page++) {
  //         if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
  //           pageCanvas.height = pxFullHeight % pxPageHeight;
  //           pageHeight =
  //             (pageCanvas.height * innerPageWidth) / pageCanvas.width;
  //         }

  //         var w = pageCanvas.width;
  //         var h = pageCanvas.height;
  //         pageCtx.fillStyle = "white";
  //         pageCtx.fillRect(0, 0, w, h);
  //         pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

  //         if (page > 0) pdf.addPage();
  //         var imgData = pageCanvas.toDataURL(
  //           "image/" + image.type,
  //           image.quality
  //         );
  //         pdf.addImage(
  //           imgData,
  //           image.type,
  //           margin[1],
  //           margin[0],
  //           innerPageWidth,
  //           pageHeight
  //         );
  //       }

  //       pdf.save(`Estimate.pdf`);
  //     }
  //   );
  // };

  const handleDownload = async () => {
    const input = document.getElementById("estimate-template");

    if (!input) {
      console.error("No element found with id 'estimate-template'");
      return;
    }

    // Temporarily set increased dimensions for the PDF
    const originalStyle = input.style.cssText;
    input.style.width = "1200px"; // New increased width
    input.style.minHeight = `${1200 * 1.414}px`; // Adjust height to maintain A4 ratio

    const pdfWidthIn = 8.27; // A4 width in inches
    const pdfHeightIn = 11.69; // A4 height in inches

    html2canvas(input, {
      scale: 2, // Higher resolution
      useCORS: true, // Handle cross-origin images
      allowTaint: true,
      scrollY: 0,
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 1.0);

        const pdf = new jsPDF("p", "in", [pdfWidthIn, pdfHeightIn]);
        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidthIn, pdfHeightIn);
        pdf.save("Estimate.pdf");
      })
      .finally(() => {
        // Restore original style
        input.style.cssText = originalStyle;
      });
  };

  const handleHomeButton = () => {
    history.push("/doctor/estimates");
  };

  // const collateralImage =
  //   brandingData?.find((item) => item.name === "collateral_image.png")
  //     ?.content || null;
  // const collateralBrandStatement =
  //   brandingData?.find((item) => item.name === "branding_statements.json")
  //     ?.content.collateralBrandStatement || null;
  //     const brandingItem = brandingData?.find((item) => item.name === "branding_statements.json");
  //     const themeColour = brandingItem?.content?.themeColour || "#21cdc0"; // Extract themeColour
  // Function to decode base64 to JSON
  // function decodeBase64ToJson(base64String) {
  //   try {
  //     // Decode base64 and parse the JSON string
  //     const jsonString = atob(base64String);
  //     return JSON.parse(jsonString);
  //   } catch (error) {
  //     console.error("Failed to decode base64 or parse JSON", error);
  //     return null;
  //   }
  // }

  // // Find the 'collateral_image.png'
  // const collateralImage =
  //   brandingData?.find((item) => item.name === "collateral_image.png")?.content || null;

  // // Find the 'branding_statements.json' and decode its base64 content
  // const brandingItem = brandingData?.find((item) => item.name === "branding_statements.json");
  // const brandingContent = brandingItem ? decodeBase64ToJson(brandingItem.content) : null;

  // // Extract the 'collateralBrandStatement' and 'themeColour' from decoded JSON
  // const collateralBrandStatement = brandingContent?.collateralBrandStatement || null;
  // const themeColour = brandingContent?.themeColour || "#21cdc0";

  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Extract the 'collateralBrandStatement' and 'themeColour' from JSON
  const collateralBrandStatement =
    brandingContent?.collateralBrandStatement || null;
  const themeColour = brandingContent?.themeColour || "#21cdc0";

  // Find the 'collateral_image.png' and get its base64 content directly
  const collateralImageItem = brandingData?.find(
    (item) => item.name === "collateral_image"
  );
  const collateralImage = collateralImageItem?.content || null;

  // Find the 'email_banner.png' and get its base64 content directly
  const emailBannerItem = brandingData?.find(
    (item) => item.name === "email_banner"
  );
  const emailBanner = emailBannerItem?.content || null;

  return (
    <>
      <Card
        style={{
          width: "85%",
          height: "100%",
          padding: "16px",
          marginLeft: "10%",
          marginTop: "5%",
        }}
      >
        <div id="estimate-template">
          {data ? (
            <Card style={{ height: "auto" }}>
              {/* Invoice Header with Colored Bar */}
              <Grid
                container
                style={{ backgroundColor: themeColour,border: `2px solid ${themeColour}`, padding: "20px" }}
              >
                {/* <Grid item xs={6}>
                  <Typography
                    variant="h4"
                    style={{ color: "black", fontWeight: "bold" }}
                  >
                    ESTIMATE
                  </Typography>
                </Grid> */}
                <Grid item xs={6}>
                  {/* <Typography
                    variant="h4"
                    style={{ color: "black", fontWeight: "bold" }}
                  >
                    ESTIMATE
                  </Typography> */}
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "1.2rem", md: "1.8rem" },
                    }}
                  >
                    ESTIMATE
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {collateralImage && (
                    <img
                      src={`data:image/png;base64,${collateralImage}`}
                      alt="Collateral"
                      width="100px"
                      height="60px"
                      style={{ paddingBottom: "3px", paddingTop: "5px" }}
                    />
                  )}
                  {/* {collateralBrandStatement && (
                    <Typography variant="subtitle1" color="grey">
                      {collateralBrandStatement}
                    </Typography>
                  )} */}
                </Grid>
              </Grid>

              {/* Billed To and Invoice Details */}
              <Grid container style={{ padding: "20px", marginTop: "10px" }}>
                <Grid item xs={6}>
                  <Typography variant="h6" style={{ fontWeight: "bold" }}>
                    Billed To
                  </Typography>
                  <Typography variant="subtitle1">
                    {displayPatientName(data.patient_name)}
                  </Typography>
                  <Typography variant="subtitle1">{data.address}</Typography>
                  <Typography variant="subtitle1">{data.phone}</Typography>
                </Grid>
                <Grid item xs={6} style={{ textAlign: "right" }}>
                  <Typography variant="h6" style={{ fontWeight: "bold" }}>
                    Estimate No: {data.estimate_number}
                  </Typography>
                  <Typography variant="subtitle1">
                    Date: {data.estimate_date}
                  </Typography>
                </Grid>
              </Grid>

              {/* Item Table */}
              <Grid item xs={12} style={{ padding: "20px" }}>
                <Grid
                  container
                  style={{
                    borderTop: "1px solid #ccc",
                    borderBottom: "1px solid #ccc",
                    padding: "10px",
                    fontWeight: "bold",
                  }}
                >
                  <Grid item xs={4}>
                    items
                  </Grid>
                  <Grid item xs={2}>
                    Unit Cost (₹)
                  </Grid>
                  <Grid item xs={2}>
                    Qty
                  </Grid>
                  <Grid item xs={2}>
                    Amount (₹)
                  </Grid>
                </Grid>

                {data.items.map((item, index) => (
                  <Grid
                    container
                    key={index}
                    style={{
                      borderBottom: "1px solid #ccc",
                      padding: "10px 0",
                    }}
                  >
                    <Grid item xs={4}>
                      {item.item_name}
                    </Grid>
                    <Grid item xs={2}>
                      ₹{item.item_price}
                    </Grid>
                    <Grid item xs={2}>
                      {item.quantity}
                    </Grid>
                    <Grid item xs={2}>
                      ₹{item.subtotal}
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              {/* Total and Footer */}
              <Grid container style={{ padding: "20px" }}>
                <Grid item xs={12} style={{ textAlign: "right" }}>
                  <Typography variant="subtitle1">
                    Subtotal: ₹{data.total_amount}
                  </Typography>
                  <Typography variant="subtitle1">
                    Discount(%): {data.discount}
                  </Typography>
                  <Typography variant="subtitle1">
                    Tax(%): {data.tax}
                  </Typography>
                  <Typography variant="h6" style={{ fontWeight: "bold" }}>
                    Total: ₹{data.total}
                  </Typography>
                </Grid>
              </Grid>
              {/* Invoice Terms */}
              <Grid container style={{ padding: "20px" }}>
                <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                  Estimate Terms:
                </Typography>
                <Typography variant="subtitle1">
                  Please pay your Estimate before {data.expiry_date}.
                </Typography>
              </Grid>

              {/* Footer */}
              <FooterPdfTemplate />
            </Card>
          ) : (
            <h1>Loading Estimate</h1>
          )}
        </div>
        {/* <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button
            onClick={handleDownload}
            className="listening-button"
            style={{ marginRight: "10px" }}
          >
            Download
          </button>

          <button onClick={handleHomeButton} className="listening-button">
            Go to Home
          </button>
        </div> */}

        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={2}
          style={{ outline: 'none', border: 'none', marginTop: "20px" }}
        >
          <Grid item xs={12} sm={5} md={5} lg={4} style={{textAlign: "center"}}>
            <button
             type="button"
              className="btn btn__secondary btn__rounded btn__block mt-2"
              onClick={handleDownload}
              // onMouseEnter={(e) => {
              //   e.target.style.background = "#99E8E2 !important";
              //   e.target.style.color = "#000000 !important";
              //   e.target.style.border = "2px solid #2196F3 !important";
              // }}
              // onMouseLeave={(e) => {
              //   e.target.style.background = "#D0EAD1 !important";
              //   e.target.style.color = "#017B40 !important";
              //   e.target.style.border = "2px solid #85C988 !important";
              // }}
              // sx={{
              //   all: 'unset', // Resets all inherited MUI and browser styles
              //   background: "#D0EAD1 !important",
              //   color: "#017B40 !important",
              //   border: "2px solid #85C988 !important",
              //   padding: "6px 5px 6px 5px !important",
              //   borderRadius: "10px !important",
              //   fontSize: "28px !important",
              //   fontStyle: "medium !important",
              //   cursor: "pointer !important",
              //   // display: "inline-block !important",
              //   width: "100% !important", // Ensures the button fills the grid item
              //   "&:hover": {
              //     background: "#99E8E2 !important",
              //     color: "#000000 !important",
              //     border: "2px solid #2196F3 !important",
              //   },
              // }}
              style={{
                color: "white",
                padding: "6px 5px 6px 5px !important",
                width: "100%",
                // transition: "background-color 0.3s ease",
                backgroundColor: "#0e3f66",
                borderRadius: "10px",
                // boxShadow: "0px 4px 4px 0px #00000040 inset"
                fontSize: "28px !important",
              }}
            >
              DOWNLOAD ESTIMATE
            </button>
          </Grid>
          <Grid item xs={12} sm={5} md={5} lg={4} style={{ marginLeft: "auto", textAlign: "center", marginRight: "2.5vh" }}>
            {/* <div style={{ maxWidth: '100%', flexGrow: 1 }}> */}
            <button
             type="button"
              className="btn btn__secondary btn__rounded btn__block mt-2"
              onClick={handleHomeButton}
              // onMouseEnter={(e) => {
              //   e.target.style.background = "#99E8E2 !important";
              //   e.target.style.color = "#000000 !important";
              //   e.target.style.border = "2px solid #2196F3 !important";
              // }}
              // onMouseLeave={(e) => {
              //   e.target.style.background = "#D0EAD1 !important";
              //   e.target.style.color = "#017B40 !important";
              //   e.target.style.border = "2px solid #85C988 !important";
              // }}
              // style={{
              //   all: 'unset', // Resets all inherited MUI and browser styles
              //   background: "#D0EAD1 !important",
              //   color: "#017B40 !important",
              //   border: "2px solid #85C988 !important",
              //   padding: "6px 5px 6px 5px !important",
              //   borderRadius: "10px !important",
              //   fontSize: "28px !important",
              //   fontStyle: "medium !important",
              //   cursor: "pointer !important",
              //   // display: "inline-block !important",
              //   width: "100% !important", // Ensures the button fills the grid item
              //   "&:hover": {
              //     background: "#99E8E2 !important",
              //     color: "#000000 !important",
              //     border: "2px solid #2196F3 !important",
              //   }
              // }}
              style={{
                color: "white",
                padding: "6px 5px 6px 5px !important",
                width: "100%",
                // transition: "background-color 0.3s ease",
                backgroundColor: "#0e3f66",
                borderRadius: "10px",
                // boxShadow: "0px 4px 4px 0px #00000040 inset"
                fontSize: "28px !important",
              }}
            >
             GO TO HOME
            </button>
            {/* </div> */}
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export default ViewEstimate;
